module.exports = __webpack_public_path__ + "img/36.95b49250.jpg";